import axios from 'axios';
import '../services/GlobalVariables';

const PRINT_BEHAVIOR_STORAGE_KEY = 'posPrintBehaviorSettings';
const API_URL = `${global.SET_API_URL}printBehaviorSettings/`;

export const KOT_PRINTER_MODES = {
    NETWORK: 'network',
    SYSTEM: 'system'
};

const DEFAULT_PRINT_BEHAVIOR_SETTINGS = {
    kot: true,
    separateItemKot: false,
    kotPrinterMode: KOT_PRINTER_MODES.NETWORK,
    completeOrder: true,
    tempBill: true,
    finalBill: true,
    deliveryNote: true,
    deliveryBarcode: true
};

const normalizeKotPrinterMode = (value) => (
    value === KOT_PRINTER_MODES.SYSTEM ? KOT_PRINTER_MODES.SYSTEM : KOT_PRINTER_MODES.NETWORK
);

const normalizePrintBehaviorSettings = (settings) => {
    const source = settings && typeof settings === 'object' ? settings : {};
    return {
        kot: source.kot !== undefined ? Boolean(source.kot) : DEFAULT_PRINT_BEHAVIOR_SETTINGS.kot,
        separateItemKot: source.separateItemKot !== undefined ? Boolean(source.separateItemKot) : DEFAULT_PRINT_BEHAVIOR_SETTINGS.separateItemKot,
        kotPrinterMode: normalizeKotPrinterMode(source.kotPrinterMode),
        completeOrder: source.completeOrder !== undefined ? Boolean(source.completeOrder) : DEFAULT_PRINT_BEHAVIOR_SETTINGS.completeOrder,
        tempBill: source.tempBill !== undefined ? Boolean(source.tempBill) : DEFAULT_PRINT_BEHAVIOR_SETTINGS.tempBill,
        finalBill: source.finalBill !== undefined ? Boolean(source.finalBill) : DEFAULT_PRINT_BEHAVIOR_SETTINGS.finalBill,
        deliveryNote: source.deliveryNote !== undefined ? Boolean(source.deliveryNote) : DEFAULT_PRINT_BEHAVIOR_SETTINGS.deliveryNote,
        deliveryBarcode: source.deliveryBarcode !== undefined ? Boolean(source.deliveryBarcode) : DEFAULT_PRINT_BEHAVIOR_SETTINGS.deliveryBarcode
    };
};

export const getDefaultPrintBehaviorSettings = () => ({ ...DEFAULT_PRINT_BEHAVIOR_SETTINGS });

export const getPrintBehaviorSettings = () => {
    if (typeof window === 'undefined' || !window.localStorage) {
        return getDefaultPrintBehaviorSettings();
    }

    try {
        const raw = window.localStorage.getItem(PRINT_BEHAVIOR_STORAGE_KEY);
        if (!raw) {
            return getDefaultPrintBehaviorSettings();
        }

        const parsed = JSON.parse(raw);
        return normalizePrintBehaviorSettings(parsed);
    } catch (error) {
        console.warn('Unable to parse print behavior settings, using defaults.', error);
        return getDefaultPrintBehaviorSettings();
    }
};

const cachePrintBehaviorSettings = (settings) => {
    const normalized = normalizePrintBehaviorSettings(settings);

    if (typeof window !== 'undefined' && window.localStorage) {
        window.localStorage.setItem(PRINT_BEHAVIOR_STORAGE_KEY, JSON.stringify(normalized));
    }

    return normalized;
};

export const fetchPrintBehaviorSettings = async () => {
    try {
        const response = await axios.get(API_URL);
        return cachePrintBehaviorSettings(response.data?.data || DEFAULT_PRINT_BEHAVIOR_SETTINGS);
    } catch (error) {
        console.warn('Unable to load central print behavior settings; using cached settings.', error);
        return getPrintBehaviorSettings();
    }
};

export const savePrintBehaviorSettings = async (settings) => {
    const normalized = normalizePrintBehaviorSettings(settings);
    const response = await axios.post(API_URL, normalized);
    return cachePrintBehaviorSettings(response.data?.data || normalized);
};

export const resetPrintBehaviorSettings = async () => {
    const defaults = getDefaultPrintBehaviorSettings();
    return await savePrintBehaviorSettings(defaults);
};

export const isPrintActionEnabled = (actionKey) => {
    const settings = getPrintBehaviorSettings();
    return Boolean(settings[actionKey]);
};
